/* eslint-disable @angular-eslint/directive-selector */
/* eslint-disable @typescript-eslint/naming-convention */
import { Directive, ElementRef, HostListener } from '@angular/core';
import { ConstantValues } from '../models/util/constantValues';
import { OfficeNumberRounding } from '../models/enums';

@Directive({

    // tslint:disable-next-line:directive-selector
    selector: '[numberOnly]'
})
export class NumberOnlyDirective {
    // Allow decimal numbers. The \. is only allowed once to occur
    // private regex: RegExp = new RegExp(/^[0-9]+(\.([0-9]{1,2})?)?$/g);
    private regex = new RegExp(/^[0-9]+(\.([0-9]{1,2})?)?$/g);
    // Allow key codes for special events. Reflect :
    private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'Delete', 'Del', 'ArrowLeft', 'Left', 'ArrowRight', 'Right'];

    constructor(private el: ElementRef) {
    }

    @HostListener('keypress', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        // Allow special keys
        // console.log(event.key)
        // console.log(this.specialKeys.indexOf(event.key));

        if (this.specialKeys.indexOf(event.key) !== -1) {
            return;
        }


        // Do not use event.keycode this is deprecated.
        // See: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
        const current: string = this.el.nativeElement.value;
        // works with type tel
        let position: number = this.el.nativeElement.selectionStart;

        // mobile - type "number"
        if (position == null) {
            position = current.length;
        }

        // We need this because the current value on the DOM element
        // is not yet updated with the value from this event
        // let next: string = current.concat(event.key);

        // for Edge
        let keyPress: string = event.key;
        if (event.key === 'Decimal' || event.key === ',') {
            keyPress = '.';
        }

        if (keyPress === '.' && position === 0) {
            event.preventDefault();
            return;
        }

        if (event.key === ',') {
            if (current.indexOf('.') === -1 && ConstantValues.NUMBER_ROUNDING !== OfficeNumberRounding.WholeNumber) {
                const slice = position + 3;
                this.el.nativeElement.value = current.slice(0, slice) + '.';
            }
            event.preventDefault();
        }

        const val: string = current.slice(0, position) + keyPress + current.slice(position, current.length);

        // tslint:disable-next-line:radix
        if (parseInt(val.substring(0, val.length - 1)) === ConstantValues.MAX_STAKE) {
            // this.el.nativeElement.value = this.MAX_STAKE;
             event.preventDefault();
            // TicketBase.totalStakeStatic = this.el.nativeElement.value;
        }

        switch (ConstantValues.NUMBER_ROUNDING) {
            case OfficeNumberRounding.WholeNumber:
                this.regex = new RegExp(/^\d*$/g);
                break;
            case OfficeNumberRounding.HalfNumber:
                this.regex = new RegExp(/^[0-9]+(\.[5][0]?)?$/g);
                break;
            case OfficeNumberRounding.OneDecimal:
                this.regex = new RegExp(/^[0-9]+(\.[0-9][0]?)?$/g);
                break;
            case OfficeNumberRounding.TwoDecimal:
                this.regex = new RegExp(/^[0-9]+(\.([0-9]{1,2})?)?$/g);
                break;
        }

        if (val && !String(val).match(this.regex)) {
            if (event.key === 'Decimal' || event.key === '.') {
                if (current.indexOf('.') === -1 && ConstantValues.NUMBER_ROUNDING !== OfficeNumberRounding.WholeNumber) {
                    const slice = position + 3;
                    this.el.nativeElement.value = val.slice(0, slice);
                } else {
                    event.preventDefault();
                }

            }
            event.preventDefault();
        } else {

            if (position === 0 && (event.key === '.' || event.key === ',')) {
                event.preventDefault();
            }

        }

    }

    @HostListener('keyup', ['$event'])
    onKeyUp(event: KeyboardEvent) {
        const current: string = this.el.nativeElement.value;
        // let position: number = this.el.nativeElement.selectionStart;

        if (event.key === 'Delete' || event.key === 'Del' || event.key === 'Delete' || event.key === 'Backspace') {
            if (current[0] === '.') {
                this.el.nativeElement.value = current.replace('.', '');
            }
            return;
        }
    }

    @HostListener('focusout', ['$event'])
    public focusOut(event: any): void {
        const current: string = this.el.nativeElement.value;
        const indexOfDot = current.indexOf('.');
        if (current.length > 0) {
            if (indexOfDot < 0) {
                this.el.nativeElement.value = current + '.00';
            } else if (current.length - 1 === indexOfDot) {
                this.el.nativeElement.value = current + '00';
            } else if (current.length - 2 === indexOfDot) {
                this.el.nativeElement.value = current + '0';
            }
        } else {
            this.el.nativeElement.value = '0.00';
        }
    }

    @HostListener('focus', ['$event'])
    public focus(event: any): void {
        const current: string = this.el.nativeElement.value;
        const indexOfDot = current.indexOf('.');

        switch (ConstantValues.NUMBER_ROUNDING) {
            case OfficeNumberRounding.WholeNumber:
                this.el.nativeElement.value = indexOfDot > 0 ? current.slice(0, current.indexOf('.')) : current;
                break;
            default:
                if (current.indexOf('.00') !== -1) {
                    this.el.nativeElement.value = current.slice(0, current.indexOf('.'));
                } else if (indexOfDot !== -1 && current[current.length - 1] === '0') {
                    this.el.nativeElement.value = current.slice(0, current.length - 1);
                }
                break;
        }
    }
}
